import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { from, map, Observable } from 'rxjs';
import { AuthService } from './services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        return from(this.authService.app.auth.getSession()).pipe(
            map(({ data }) => {
                if (data.session) {
                    return true;
                }
                this.router.navigate(['/auth/login']).then();
                return false;
            }),
        );
    }
}
